import _ from 'lodash'
import React, { useMemo, useEffect, useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { Map, fromJS } from 'immutable'
import { ProjectThemeStyle } from './ProjectThemeStyle'
import { ElementStyle, ElementStyleChunk } from './ElementStyle'
import { ProjectDeviceStyles } from './ProjectDeviceStyles'
import { useLayoutMode } from '../../../hooks/useLayoutMode'
import { DEVICE_DEFAULT_MAX_SIZE } from '../../../lib/DEVICE_DEFAULT_MAX_SIZE'
import { PageElementsPositions } from './Components/PageElementsPositions'
import { transformCSSPositionValue, useProjectComponent } from '../../../hooks/useWidgetComponent'
import { StyleElement } from '../../Main/StyleElement'
import { ProjectElementsPositions } from './Components/ProjectElementsPositions'
// import ProjectCustomFavIcon from './ProjectCustomFavIcon'
import { ElementFormFieldStyle, FormFieldElementsDimensions, ProjectFormFieldStyle } from './FormFieldStyle'
import { isSame } from './isSame'
import { getElementDataRoot } from '../../../constants/getElementDataRoot'
import { getFormColsCount, getFormRowsCount } from '../../../lib/FormLib'
import { IS_SERVER } from '../../../constants/ssr'
import { sendLWCSizeToParent } from '../../../store/project/sendLWCSizeToParent'
import { parseURLParameters } from '../../../lib/common'
import { LAYOUT_MODE } from '../../../constants/toUnits'
import { useIsLandingProject } from '../../../hooks/useIsLandingProject'
import { getPersistentDrawerWidth } from '../../../lib/processPortalRules'
import { RenderStripStyles } from './RenderStripStyles'
import { ClientRender } from './ClientRender'
import { CHAT_BOT_TYPE } from '../../../constants/features'
import { getStyle } from '../../../constants/getStyle'
import { PREVIEW_PAGE_ID } from '../../../constants/PREVIEW_PAGE_ID'
import { collectModalsID, collectModalsIDChildren } from '../../../lib/collectModalsID'
import { storeGlobalBrowserVariable, GLOBAL_VAR_KEYS } from '../../../lib/globalUtils'

const STATIC_PAGES = ['signin', 'login', 'profile', 'register', 'e_checkout', 'e_catalog', 'e_product', 'e_cart']

export const getStripRootMeta = (state) => {
  const isFluidWidth = state.getIn(['project', 'Settings', 'responsiveAIConf', 'isFluidWidth'], false)
  const getStripRootPath = (mode, key, def) =>
    state.getIn(['project', 'Settings', 'theme', mode, 'Page', 'root', key], def)

  let page = state.getIn(['page'], '')
  const lgPageWidth = state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', page, 'width'])
  const lgPageWidthUnit = state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', page, 'widthUnit'], 'px')

  let isConfiguredDevice = state.getIn(['pages', page, 'Props', 'IsConfiguredDevice'], Map())
  let lgWidth = getStripRootPath('lg', 'width', '1367')
  let lgWidthUnit = getStripRootPath('lg', 'widthUnit', 'px')
  if (lgPageWidth) {
    lgWidth = lgPageWidth
    lgWidthUnit = lgPageWidthUnit
  }
  if (!lgWidth) {
    lgWidth = 1367
    lgWidthUnit = 'px'
  }

  let mdWidth, mdWidthUnit, smWidth, smWidthUnit, smlWidth, smlWidthUnit, xsWidth, xsWidthUnit, ssWidth, ssWidthUnit

  mdWidth = DEVICE_DEFAULT_MAX_SIZE.md
  mdWidthUnit = 'px'
  smlWidth = DEVICE_DEFAULT_MAX_SIZE.sml
  smlWidthUnit = 'px'
  smWidth = DEVICE_DEFAULT_MAX_SIZE.sm
  smWidthUnit = 'px'
  xsWidth = DEVICE_DEFAULT_MAX_SIZE.xs
  xsWidthUnit = 'px'
  ssWidth = DEVICE_DEFAULT_MAX_SIZE.ss
  ssWidthUnit = 'px'

  if (isFluidWidth) {
    return {
      ss: '100%',
      xs: '100%',
      sm: '100%',
      sml: '100%',
      md: '100%',
      lg: '100%',
    }
  }

  return {
    ss: transformCSSPositionValue(ssWidth, ssWidthUnit),
    xs: transformCSSPositionValue(xsWidth, xsWidthUnit),
    sm: transformCSSPositionValue(smWidth, smWidthUnit),
    sml: transformCSSPositionValue(smlWidth, smlWidthUnit),
    md: transformCSSPositionValue(mdWidth, mdWidthUnit),
    lg: transformCSSPositionValue(lgWidth, lgWidthUnit),
  }
}

export const getBuilderStripRootMeta = (state) => {
  const getStripRootPath = (mode, key, def) =>
    state.getIn(['project', 'Settings', 'theme', mode, 'Page', 'root', key], def)

  let page = state.getIn(['page'], '')
  const lgPageWidth = state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', page, 'width'])
  const lgPageWidthUnit = state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', page, 'widthUnit'], 'px')

  let isConfiguredDevice = state.getIn(['pages', page, 'Props', 'IsConfiguredDevice'], Map())
  let lgWidth = getStripRootPath('lg', 'width', '1367')
  let lgWidthUnit = getStripRootPath('lg', 'widthUnit', 'px')
  if (lgPageWidth) {
    lgWidth = lgPageWidth
    lgWidthUnit = lgPageWidthUnit
  }
  if (!lgWidth) {
    lgWidth = 1367
    lgWidthUnit = 'px'
  }

  let mdWidth, mdWidthUnit, smWidth, smWidthUnit, smlWidth, smlWidthUnit, xsWidth, xsWidthUnit, ssWidth, ssWidthUnit

  mdWidth = DEVICE_DEFAULT_MAX_SIZE.md
  mdWidthUnit = 'px'
  smlWidth = DEVICE_DEFAULT_MAX_SIZE.sml
  smlWidthUnit = 'px'
  smWidth = DEVICE_DEFAULT_MAX_SIZE.sm
  smWidthUnit = 'px'
  xsWidth = DEVICE_DEFAULT_MAX_SIZE.xs
  xsWidthUnit = 'px'
  ssWidth = DEVICE_DEFAULT_MAX_SIZE.ss
  ssWidthUnit = 'px'

  return {
    ss: transformCSSPositionValue(ssWidth, ssWidthUnit),
    xs: transformCSSPositionValue(xsWidth, xsWidthUnit),
    sm: transformCSSPositionValue(smWidth, smWidthUnit),
    sml: transformCSSPositionValue(smlWidth, smlWidthUnit),
    md: transformCSSPositionValue(mdWidth, mdWidthUnit),
    lg: transformCSSPositionValue(lgWidth, lgWidthUnit),
  }
}

export const getFormStyles = (uid, el, style, layoutMode) => {
  const rows = getFormRowsCount(el, layoutMode)
  const cols = getFormColsCount(el, layoutMode)
  let txtStyle = `.ft--${uid}--root{height: fit-content !important;}
    .ft--${uid}--col{width: calc((100% - ${cols - 1}px) / ${cols});}`

  _.times(cols, (n) => {
    if (style.getIn(['cols', layoutMode, String(n)])) {
      let initialWidth = style.getIn(['cols', layoutMode, String(n)])
      if (_.endsWith(initialWidth, 'px')) {
        initialWidth = String(initialWidth).replace('px', '')
      }
      const width = transformCSSPositionValue(initialWidth, style.getIn(['cols', layoutMode, `${n}Unit`], 'px'))
      txtStyle += `.ft--${uid}--col-${n}{width: ${width};}`
    }
  })
  // el.getIn(['props', layoutMode, 'children'], Map())   .map((row, rowID) => {
  //     if (style.getIn(['rows', layoutMode, String(rowID)])) {
  //         txtStyle += `.ft--${uid}--row-${rowID}{height: ${style.getIn(['rows', layoutMode, String(rowID)])};}`
  //     }
  // })
  for (let col = 2; col <= cols; col++) {
    txtStyle += `.ft--${uid}--colspan-${col}{width: calc(((100% - ${cols - 1}px) / ${cols}) * ${col})l}`
  }

  return txtStyle
}

function PageFormStyle() {
  const pageID = useSelector((state) => state.getIn(['page']))
  return <FormStyle target={pageID} />
}

export function FormStyle({ target }) {
  const layoutMode = useLayoutMode()
  const ModalElementsID = useSelector(collectModalsID, shallowEqual)
  const formElements = useSelector(
    (state) =>
      state
        .getIn([...getElementDataRoot(target), 'elements'], Map())
        .filter((elem, uid) => elem.get('type') === 'Form' && !ModalElementsID.includes(uid)),
    isSame
  )
  const formStyles = useSelector(
    (state) =>
      formElements.reduce((r, v) => {
        let ref = v.getIn(['props', 'styleRef'])
        const isGlobalStyle = state.getIn(['project', 'Settings', 'styles', ref, 'isGlobal'])
        if (isGlobalStyle) {
          return r.set(ref, state.getIn(['project', 'Settings', 'styles', ref], Map()))
        }
        return r.set(ref, state.getIn([...getElementDataRoot(target), 'styles', ref], Map()))
      }, Map()),
    isSame
  )

  const styleTxt = useMemo(() => {
    let styles = []
    formElements.map((el, uid) => {
      let style = formStyles.get(el.getIn(['props', 'styleRef']), Map())
      styles.push(getFormStyles(uid, el, style, layoutMode))
    })

    return styles.join('')
  }, [formElements, formStyles, layoutMode])

  if (styleTxt) {
    return <StyleElement key={`formstyle-${target}`} uid={`formstyle-${target}`} style={styleTxt} />
  } else {
    return null
  }
}

export function ModalFormStyle({ target, modalID }) {
  const layoutMode = useLayoutMode()
  const ModalElementsID = useSelector(collectModalsIDChildren(modalID), shallowEqual)
  const formElements = useSelector(
    (state) =>
      state
        .getIn([...getElementDataRoot(target), 'elements'], Map())
        .filter((elem, uid) => elem.get('type') === 'Form' && ModalElementsID.includes(uid)),
    isSame
  )
  const formStyles = useSelector(
    (state) =>
      formElements.reduce((r, v) => {
        let ref = v.getIn(['props', 'styleRef'])
        const isGlobalStyle = state.getIn(['project', 'Settings', 'styles', ref, 'isGlobal'])
        if (isGlobalStyle) {
          return r.set(ref, state.getIn(['project', 'Settings', 'styles', ref], Map()))
        }
        return r.set(ref, state.getIn([...getElementDataRoot(target), 'styles', ref], Map()))
      }, Map()),
    isSame
  )

  const styleTxt = useMemo(() => {
    let styles = []
    formElements.map((el, uid) => {
      let style = formStyles.get(el.getIn(['props', 'styleRef']), Map())
      styles.push(getFormStyles(uid, el, style, layoutMode))
    })

    return styles.join('')
  }, [formElements, formStyles, layoutMode])

  if (styleTxt) {
    return <StyleElement key={`formstyle-${target}`} uid={`formstyle-${target}`} style={styleTxt} />
  } else {
    return null
  }
}

const panelThemeStyle = `.ft--theme--Section--root.show::before, .ft--theme--Stack--root.show::before{position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);user-select: none;display: inline-flex;justify-self: center;align-self: center;font-size: 10px;color: #000;background-color: #fff;z-index: 1;text-align: center;vertical-align: middle;content: "Drop element to panel";},.ft--theme--Tab--tabPanel.show::before{position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);user-select: none;display: inline-flex;justify-self: center;align-self: center;font-size: 10px;color: #000;background-color: #fff;z-index: 1;text-align: center;vertical-align: middle;content: "Drop element to panel";}`

function ProjectPreviewDeviceStyle({ width }) {
  const page = useSelector((state) => state.get('page'))
  let params = parseURLParameters()
  let useFixedDevice = false
  if (page !== 'surveyEmail' && params && params.device && LAYOUT_MODE.indexOf(params.device) > -1) {
    useFixedDevice = true
  }
  let key = params.device === 'lg' ? 'min-width' : 'width'
  return (
    <style
      data-uid={`proj-dev-prev-${params.device}`}
      type="text/css"
      dangerouslySetInnerHTML={{
        __html: useFixedDevice
          ? `body{${key}: ${width}!important;margin: 0 auto !important;}.ft--theme--Window--root{overflow-x: hidden!important;}`
          : '',
      }}
      suppressHydrationWarning={true}
    />
  )
}

const RenderProjectStyles = ({ isPreview = false }) => {
  const layoutMode = useLayoutMode()
  const stripRoot = useSelector(getStripRootMeta, shallowEqual)
  const projectID = useSelector((state) => state.getIn(['project', '_id']))
  const ModalElementsID = useSelector(collectModalsID, shallowEqual)
  const projectElementStyles = useSelector(
    (state) =>
      state
        .getIn(['project', 'Settings', 'styles'], Map())
        .reduce((ret, v, k) => (ModalElementsID.includes(k) ? ret : [...ret, k]), []),
    shallowEqual
  )

  const projectElementStylesChunk = useMemo(() => {
    let chunks = []

    const chunkCount = Math.ceil(projectElementStyles.length / 25)
    _.times(chunkCount, (n) => {
      let styles = []
      projectElementStyles.slice(n * 25, (n + 1) * 25).map((uid) => {
        styles.push(uid)
      })
      chunks.push(styles)
    })

    return chunks
  }, [projectElementStyles])
  return _.map(projectElementStylesChunk, (chunk, index) => (
    <ElementStyleChunk
      key={`proj${projectID}${index}`}
      chunk={chunk}
      pageID="project"
      mode={layoutMode}
      stripRoot={stripRoot}
      isPreview={isPreview}
    />
  ))
}

export const RenderPageStyles = ({ isPreview = false, customPageID }) => {
  const layoutMode = useLayoutMode()
  const stripRoot = useSelector(getStripRootMeta, shallowEqual)
  const pageID = useSelector((state) => customPageID || state.getIn(['page']))
  let elementStyles = useSelector(
    (state) => state.getIn(['pages', pageID, 'Props', 'styles'], Map()).reduce((ret, v, k) => [...ret, k], []),
    shallowEqual
  )
  const pageElemStyles = useMemo(() => {
    let chunks = []
    const chunkCount = Math.ceil(elementStyles.length / 25)
    _.times(chunkCount, (n) => {
      let styles = []
      elementStyles.slice(n * 25, (n + 1) * 25).map((uid) => {
        styles.push(uid)
      })

      chunks.push(styles)
    })

    return chunks
  }, [elementStyles])

  useEffect(
    function () {
      if (!IS_SERVER) {
        sendLWCSizeToParent()
        setTimeout(function () {
          sendLWCSizeToParent()
        }, 500)
      }
    },
    [elementStyles]
  )

  return _.map(pageElemStyles, (chunk, index) => (
    <ElementStyleChunk
      key={`chunk${pageID}${index}${layoutMode}`}
      chunk={chunk}
      pageID={pageID}
      mode={layoutMode}
      stripRoot={stripRoot}
      isPreview={isPreview}
    />
  ))
}

const RenderProjectThemeStyles = ({ isPreview = false }) => {
  const layoutMode = useLayoutMode()
  const stripRoot = useSelector(getStripRootMeta, shallowEqual)
  const useSmartV = useSelector((state) => state.getIn(['project', 'isPublic'], true) === false)
  const themeStyles = useSelector((state) => {
    let types = [
      'Strip',
      'redirectModal',
      'webnotify',
      'Window',
      'Page',
      'Toast',
      'confirmModal',
      'ConfirmationModal',
      'formsuccessMsg',
      'formerrorMsg',
      'sfNotificationMsg',
      'sfPreloaderMsg',
      'lookupModal',
      'chartModal',
      'dateRangeModal',
      'infoModal',
      'warningModal',
      'DrawerEl',
      'Modal',
      'form',
      'UserTip',
      'PreviewAction',
      'ellipsysModal',
      ...state
        .getIn(['pages', state.getIn(['page']), 'Props', 'elements'], Map())
        .map((el) => {
          if (el.get('type') == 'Widget') {
            return el.getIn(['props', 'data', 'Type'], '')
          } else {
            return el.get('type')
          }
        })
        .toList()
        .toJS(),
      ...state
        .getIn(['project', 'Settings', 'elements'], Map())
        .map((el) => el.get('type'))
        .toList()
        .toJS(),
    ]
    if (!isPreview) {
      types.push('PowerTable')
      types.push('Typography')
      types.push('Button')
      types.push('Link')
      state.getIn(['pages', PREVIEW_PAGE_ID, 'Props', 'elements'], Map()).map((el) => {
        if (el.get('type') == 'Widget') {
          types.push(el.getIn(['props', 'data', 'Type'], ''))
        } else {
          types.push(el.get('type'))
        }
      })
    }
    if (state.getIn(['project', 'ProjectType']) === CHAT_BOT_TYPE) {
      types.push('Bot')
    }
    if (state.getIn(['project', 'Settings', 'coBrowse', 'status'], false)) {
      types.push('CoBrowse')
    }
    if (
      state.getIn(['project', 'Settings', 'store', 'public'], Map()).filter((conf) => conf.get('type') === 'DOCGEN')
        .size > 0
    ) {
      types.push('IntDocGen')
    }
    if (types.includes('Kanban')) {
      types.push('KanbanEditFields')
    }
    if (types.includes('Scheduler')) {
      types.push(...['sProfile', 'sMTypes', 'sCalendar', 'sTime', 'sForm', 'SchedulerField', 'form', 'sOk'])
    }
    if (types.includes('SmartVLoginForm')) {
      types.push('SmartVLoginFormField')
    }
    if (types.includes('SmartVOtpForm')) {
      types.push('SmartVOtpFormField')
    }
    if (state.getIn(['project', 'Settings', 'Header', 'enable'], false)) {
      types.push('Header')
    }
    if (state.getIn(['project', 'Settings', 'Footer', 'enable'], false)) {
      types.push('Footer')
    }
    if (types.includes('chart')) {
      types.push(
        'chart__pie',
        'chart__doughnut',
        'chart__horizontalBar',
        'chart__bar',
        'chart__line',
        'chart__stepLine',
        'chart__bubble',
        'chart__scatter',
        'chart__stacked',
        'chart__stackSide',
        'chart__stackLine'
      )
    }
    //always include theme drawer for mobile devices
    types.push('Drawer')
    if (types.includes('TextCounter')) {
      types.push('TextCounterField')
    }
    if (types.includes('PowerTable')) {
      types.push('PowerTableField')
      types.push('PowerTableFilterField')
      types.push('PowerTableGFilterField')
    }
    if (types.includes('FormField')) {
      types.push('dateRangeModal')
    }
    if (state.getIn(['project', 'isPublic'], true) === false || !state.getIn(['project'])) {
      let loginVariant = state.getIn(['project', 'Settings', 'SmartV', 'loginVariant'], '')
      types.push(...['SmartVLoginField', 'SmartVLoginFormField'])
      if (loginVariant === '') {
        types.push(...['SmartVLoginPage'])
      } else if (loginVariant === 'split-screen') {
        types.push(...['split-login'])
      } else if (loginVariant === 'split-screen-flipped') {
        types.push(...['fsplit-login'])
      } else if (loginVariant === 'clean-simple') {
        types.push(...['csimple-login'])
      } else if (loginVariant === 'clean-simple-flipped') {
        types.push(...['fcsimple-login'])
      }
      if (state.getIn(['project', 'Settings', 'SmartV', 'useRegister'])) {
        let regVariant = state.getIn(['project', 'Settings', 'SmartV', 'regVariant'], '')
        types.push(...['SmartVRegField', 'SmartVLoginFormField'])
        if (regVariant === '') {
          types.push(...['SmartVSignUpPage'])
        } else if (regVariant === 'split-screen') {
          types.push(...['split-reg'])
        } else if (regVariant === 'split-screen-flipped') {
          types.push(...['fsplit-reg'])
        } else if (regVariant === 'clean-simple') {
          types.push(...['csimple-reg'])
        } else if (regVariant === 'clean-simple-flipped') {
          types.push(...['fcsimple-reg'])
        }
      }
      if (state.getIn(['project', 'Settings', 'SmartV', 'useProfile'])) {
        types.push(...['SmartVProfilePage', 'SmartVProfileField'])
      }
      if (!state.getIn(['project', 'Settings', 'SmartV', 'IsDisable2FA'], false)) {
        types.push('SmartVVerfField')
        let verifyVariant = state.getIn(['project', 'Settings', 'SmartV', 'verifyVariant'], '')
        if (verifyVariant === '') {
          types.push(...['SmartVVerificationPage'])
        } else if (verifyVariant === 'split-screen') {
          types.push(...['split-ver'])
        } else if (verifyVariant === 'split-screen-flipped') {
          types.push(...['fsplit-ver'])
        } else if (verifyVariant === 'clean-simple') {
          types.push(...['csimple-ver'])
        } else if (verifyVariant === 'clean-simple-flipped') {
          types.push(...['fcsimple-ver'])
        }
      }
    }
    if (state.getIn(['project', 'Settings', 'eCommerce', 'enable'], false)) {
      types.push(
        ...[
          'eComSlide',
          'eComCart',
          'eComCartPage',
          'eSumPanel',
          'eComCheck',
          'eComPaymentDlg',
          'eProdDlg',
          'eComRelProd',
          'eComCat',
          'eComProd',

          'EComBadge',
          'EComCatCtrl',
          'EComProdCtrl',
          'ECommerceCategories',

          'EComCatCtrl-Narrow',
          'EComCatCtrl-Default',
        ]
      )
    }
    return _.uniq(_.compact(types))
  }, shallowEqual)

  return (
    <ProjectThemeStyle
      mode={layoutMode}
      stripRoot={stripRoot}
      isPreview={isPreview}
      useSmartV={useSmartV}
      themeStyles={themeStyles}
    />
  )
}

const RenderProjectCustomFocusStyles = ({ isPreview }) => {
  const allowCustomFocus = useSelector((state) => state.getIn(['project', 'Settings', 'ui', 'allowCustomFocus'], false))
  const customFocusStyles = useSelector((state) =>
    state.getIn(['project', 'Settings', 'theme', 'lg', 'CustomFocus', 'root'], Map())
  )

  const style = useMemo(() => {
    let obj = getStyle(customFocusStyles.toJS())
    if (obj.outlineOffset) {
      obj.outlineOffset = parseInt(obj.outlineOffset) + 'px'
    } else {
      obj.outlineOffset = 'unset'
    }
    return `:root{--titan-focus-outline: ${parseInt(obj.borderWidth, 10) || ''}px ${obj.borderStyle || ''} ${obj.borderColor || ''};--titan-focus-outline-color: ${obj.borderColor || ''};--focus-shadow: ${obj.boxShadow || 'none'}; --focus-offset: ${obj.outlineOffset}}`
  }, [customFocusStyles, allowCustomFocus])

  return isPreview && allowCustomFocus && <StyleElement key="ft-custom-focus" uid="ft-custom-focus" style={style} />
}

const RenderPageTransitionStyles = ({ isPreview }) => {
  const isLandingProject = useIsLandingProject()
  const layoutMode = useLayoutMode()
  const stripRoot = useSelector(getStripRootMeta, shallowEqual)
  const builderStripRoot = useSelector(getBuilderStripRootMeta, shallowEqual)
  const drawerWidth = useSelector(getPersistentDrawerWidth)
  const [__, setX] = useState(0)
  const isAutoScale = useSelector((state) =>
    state.getIn(['project', 'Settings', 'responsiveAIConf', 'isAutoScale'], false)
  )
  const isFluidWidth = useSelector((state) =>
    state.getIn(['project', 'Settings', 'responsiveAIConf', 'isFluidWidth'], false)
  )
  const transitionDurationRaw = useSelector((state) =>
    state.getIn(['project', 'Settings', 'ui', 'transitionDuration'], '1.5')
  )
  const pageWidth = useSelector((state) => {
    let defVal = state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', 'root', 'width'], 1367)
    return state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', state.get('page'), 'width'], defVal)
  })
  const pageWidthUnit = useSelector((state) => {
    let defVal = state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', 'root', 'widthUnit'], 'px')
    if (state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', state.get('page'), 'width'])) {
      return state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', state.get('page'), 'widthUnit'], defVal)
    } else {
      return defVal
    }
  })
  const customDrawerState = useSelector((state) => state.getIn(['state', 'drawer'], ''))
  const { component } = useProjectComponent(customDrawerState, 'project')
  const isPersistent = component.getIn(['props', layoutMode, 'isPersistent'], false)
  const headerHeight = useSelector((state) => {
    const pageID = state.get('page')
    let isHideHeader = false
    let usePage = STATIC_PAGES.includes(state.getIn(['page'], null)) ? state.getIn(['page'], null) : 'preview'
    let devPage = String(state.get('currentPage') === 'signin' ? state.get('currentPage') : usePage).replace(
      'signin',
      'login'
    )
    if (!STATIC_PAGES.includes(devPage)) {
      devPage = null
    }
    if (devPage !== null) {
      isHideHeader = state.getIn(['project', 'Settings', 'Header', 'Pages', devPage, 'isHideHeader', layoutMode], false)
    } else {
      isHideHeader = state.getIn(['pages', pageID, 'Props', 'isHideHeader', layoutMode], false)
    }
    if (customDrawerState && isPersistent) {
      return '0px'
    }
    if (state.getIn(['project', 'Settings', 'Header', 'enable'], false) && !isHideHeader) {
      let themeHeight = state.getIn(['project', 'Settings', 'theme', 'lg', 'Header', 'root', 'height'], 64)
      if (!themeHeight) {
        themeHeight = 64
      }
      let styleHeight = state.getIn(['project', 'Settings', 'styles', 'Header', 'lg', 'root', 'height'])
      if (styleHeight) {
        return `${styleHeight}px`
      } else {
        return `${themeHeight}px`
      }
    } else {
      return '0px'
    }
  })
  const footerHeight = useSelector((state) => {
    const pageID = state.get('page')
    let isHideFooter = false
    let usePage = STATIC_PAGES.includes(state.getIn(['page'], null)) ? state.getIn(['page'], null) : 'preview'
    let devPage = String(state.get('currentPage') === 'signin' ? state.get('currentPage') : usePage).replace(
      'signin',
      'login'
    )
    if (!STATIC_PAGES.includes(devPage)) {
      devPage = null
    }
    if (devPage !== null) {
      isHideFooter = state.getIn(['project', 'Settings', 'Footer', 'Pages', devPage, 'isHideFooter', layoutMode], false)
    } else {
      isHideFooter = state.getIn(['pages', pageID, 'Props', 'isHideFooter', layoutMode], false)
    }
    if (
      state.getIn(['project', 'Settings', 'Footer', 'enable'], false) &&
      !isHideFooter &&
      state.getIn(['project', 'Settings', 'Footer', 'isFloating'])
    ) {
      let themeHeight = state.getIn(['project', 'Settings', 'theme', 'lg', 'Footer', 'root', 'height'], 64)
      if (!themeHeight) {
        themeHeight = 64
      }
      let styleHeight = state.getIn(['project', 'Settings', 'styles', 'Footer', 'lg', 'root', 'height'])
      if (styleHeight) {
        return `${styleHeight}px`
      } else {
        return `${themeHeight}px`
      }
    } else {
      return '0px'
    }
  })

  useEffect(() => {
    const onResize = () => {
      requestAnimationFrame(() => setX((x) => x + 1))
    }
    if (!isFluidWidth && isAutoScale) {
      window.addEventListener('resize', onResize)
    }

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [isFluidWidth, isAutoScale])

  const pageTransitionStyle = useMemo(() => {
    let transitionDuration = parseFloat(transitionDurationRaw)
    if (_.isNaN(transitionDuration)) {
      transitionDuration = 1.5
    }
    let style = `.ft-ptd{--animate-duration: ${transitionDuration}s;}`
    if (isPreview && !isFluidWidth && isAutoScale && pageWidth && pageWidthUnit === 'px' && layoutMode === 'lg') {
      try {
        const windowWidth = window.document?.documentElement?.clientWidth || window.innerWidth
        const width = parseInt(pageWidth, 10)
        if (windowWidth != width) {
          style += `body {
                                  zoom: ${(parseFloat(windowWidth / width) - 0.05).toFixed(2)};
                                  -moz-transform: ${'scale(' + parseFloat(windowWidth / width).toFixed(2) + ')'};
                                  -moz-transform-origin: top;
                               } 
                                .no-zoom{
                                   zoom: ${0.05 + parseFloat(width / windowWidth)};
                                  -moz-transform: scale(${parseFloat(width / windowWidth).toFixed(2)});
                                  -moz-transform-origin: top;
                                }`
          storeGlobalBrowserVariable(GLOBAL_VAR_KEYS.AUTO_SCALE_ZOOM, true)
        }
      } catch (error) {
        console.error(
          `Error: component: RenderPageTransitionStyles, data: ${JSON.stringify({ isPreview, isFluidWidth, isAutoScale, pageWidth, pageWidthUnit, layoutMode })}. Failed to run window object on server.`
        )
      }
    }

    style += `:root{
            --project-drawer-width: ${drawerWidth ? drawerWidth : '0px'};
            --strip-content-margin: ${drawerWidth || isFluidWidth ? '0px' : 'auto'};
            ${
              isPreview
                ? `--content-width: ${
                    isLandingProject
                      ? layoutMode !== 'lg'
                        ? '100%'
                        : stripRoot[layoutMode]
                      : isFluidWidth
                        ? '100%'
                        : stripRoot[layoutMode]
                  };`
                : `--content-width: ${
                    isLandingProject
                      ? layoutMode !== 'lg'
                        ? '100%'
                        : builderStripRoot[layoutMode]
                      : builderStripRoot[layoutMode]
                  };`
            }
            --content-width-origin: ${DEVICE_DEFAULT_MAX_SIZE[layoutMode]}px;
            --project-header-height: ${headerHeight};
            --project-footer-height: ${footerHeight};
        }`
    return style
  }, [
    transitionDurationRaw,
    drawerWidth,
    stripRoot,
    layoutMode,
    headerHeight,
    isLandingProject,
    footerHeight,
    isPreview,
    isAutoScale,
    pageWidth,
    pageWidthUnit,
    isFluidWidth,
    __,
    builderStripRoot,
  ])

  return (
    <StyleElement
      key="page-transition"
      uid="page-transition"
      style={pageTransitionStyle}
      suppressContentEditableWarning
    />
  )
}

const RenderDeviceStyles = ({ isPreview = false }) => {
  const stripRoot = useSelector(getStripRootMeta, shallowEqual)
  // const isLWCPrivate = useSelector(state => state.getIn(['project', 'Settings', 'isLWCPrivate'], false))
  const layoutMode = useLayoutMode()

  return (
    <>
      {/* {IS_SERVER && isPreview && <ProjectDeviceStyles width={stripRoot[layoutMode]} layoutMode={layoutMode} />} */}
      {!IS_SERVER && isPreview ? <ProjectPreviewDeviceStyle width={stripRoot[layoutMode]} /> : null}
    </>
  )
}

export function ProjectStyles({ isPreview = false }) {
  return (
    <>
      {/* <ProjectCustomFavIcon isPreview={isPreview} /> */}
      <RenderPageTransitionStyles isPreview={isPreview} />
      <RenderProjectCustomFocusStyles isPreview={isPreview} />
      <RenderProjectThemeStyles isPreview={isPreview} />
      <RenderDeviceStyles isPreview={isPreview} />
      {!isPreview && <StyleElement key="theme-panel" uid="theme-panel" style={panelThemeStyle} />}
      <RenderPageStyles isPreview={isPreview} />
      <RenderProjectStyles isPreview={isPreview} />
      <RenderStripStyles isPreview={isPreview} />
      <ProjectFormFieldStyle />
      <ElementFormFieldStyle />
      <FormStyle target="project" />
      <PageFormStyle />
      <PageElementsPositions isPreview={isPreview} />
      <ProjectElementsPositions isPreview={isPreview} />
      <FormFieldElementsDimensions />
    </>
  )
}
